module.exports = __webpack_public_path__ + "img/bg-login-s2.5c717079.png";